import OrderFormComponent from "../component/restaurants/orders/OrderFormComponent";
import { useState, useEffect } from "react";
import Header from "../component/menu/Header";
import { constants, orderDefaultValues } from "../constant/constants";
import SideMenu from "../component/menu/SideMenu";
import CustomLoader from "../component/menu/CustomLoader";
import useUserStore from "../stores/store";
import ApiService from "../utils/ApiService";
import OrderFormHeaderComponent from "../component/OrderFormHeaderComponent";

export default function OrderAdd() {
  const { user, restaurantId, showNotification } = useUserStore();
  const [availableCategories, setAvailableCategories] = useState([]);
  const [availableFoods, setAvailableFoods] = useState(null);
  const [loadAvailableFoods, setLoadAvailableFoods] = useState(true);
  const [orderRecordInitValues, setOrderRecordInitValues] =
    useState(orderDefaultValues);
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [selectedFood, setSelectedFood] = useState("");
  const [totalAvailableFoods, setTotalAvailableFoods] = useState([]);

  const fetchFoodList = (categoryId) => {
    setLoadAvailableFoods(true);
    let params = { restaurantId };
    if (categoryId === "all" || categoryId === undefined) {
      params = { restaurantId };
    } else {
      params = {
        restaurantId,
        categoryId: categoryId,
      };
    }

    const token = user.token.token;
    ApiService.FOOD_SET_MENU_LIST(params, token).then((res) => {
      if (!res || (res && res.code !== 200)) {
        showNotification(res?.data?.message || "Something went wrong. Please try again later!");
        setLoadAvailableFoods(false);
        return;
      }

      if (Boolean(categoryId) === false) {
        setTotalAvailableFoods(res.payload.records);
      }

      setAvailableFoods(res.payload.records);
    });
    setLoadAvailableFoods(false);
  };

  const fetchRestaurantCategories = () => {
    // setLoadAvailableFoods(true);
    let params = {
      restaurantId,
    };
    const token = user.token.token;
    ApiService.GET_CATEGORY(params, token).then((res) => {
      if (!res || (res && res.code !== 200)) {
        showNotification(res?.data?.message || "Something went wrong. Please try again later!");
        return;
      }

      setAvailableCategories(res.payload.records);

      setOrderRecordInitValues((prev) => ({
        ...prev,
        payAfterEat: res.payload.restaurantInfo.acceptPayAfterEat,
      }));
    });
    setLoadAvailableFoods(false);
  };

  useEffect(() => {
    fetchFoodList();
    fetchRestaurantCategories();
  }, []);

  useEffect(() => {
    if (selectedCategory === 'all') {
      setAvailableFoods(totalAvailableFoods);
    } else {
      const tmpFoods = totalAvailableFoods.filter(item => item.categoryId === selectedCategory);

      setAvailableFoods(tmpFoods);
    }
  }, [selectedCategory, totalAvailableFoods]);
  
  return (
    <div className="flex flex-col bg-[#e5e7eb]">
      <CustomLoader />
      <Header
        title={""}
        menu={constants.MENU.ORDER}
        currentMenuKey={"T_4_S_4"}
      />
      <div className={`flex flex-row bg-prewhite `}>
        <SideMenu title={`McDonalds Food Chain`} menu={constants.MENU.ORDER} />
        <div className="flex flex-row p-[24px] w-full mt-[80px] ml-[80px]">
          <div className="flex flex-col w-full">
            <OrderFormHeaderComponent 
              context={'ORDER'}
              title={'Add Order'}
            />

            <div className="flex flex-col">
              <OrderFormComponent
                  context={0}
                  loadAvailableFoods={loadAvailableFoods}
                  availableCategories={availableCategories}
                  selectedCategory={selectedCategory}
                  setSelectedCategory={setSelectedCategory}
                  selectedFood={selectedFood}
                  setSelectedFood={setSelectedFood}
                  availableFoods={availableFoods}
                  totalAvailableFoods={totalAvailableFoods}
                  orderRecord={orderRecordInitValues}
                />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
